// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"8a20178d0570e9442343","263":"9625be55e90dbf72896b","264":"7d6b1be44a085d951632","317":"f2bb86ae296d22a3dfe4"}[chunkId] + ".chunk.js";
};